import { FC, HTMLProps } from 'react';

export const PlusIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_169_2743)">
        <path
          d="M14.6719 6.82812H9.17188V1.32812C9.17188 1.00521 9.05729 0.731771 8.82812 0.507812C8.59896 0.283854 8.32292 0.171875 8 0.171875C7.67708 0.171875 7.40104 0.283854 7.17188 0.507812C6.94271 0.731771 6.82812 1.00521 6.82812 1.32812V6.82812H1.32812C1.00521 6.82812 0.731771 6.94271 0.507812 7.17188C0.283854 7.40104 0.171875 7.67708 0.171875 8C0.171875 8.32292 0.283854 8.59896 0.507812 8.82812C0.731771 9.05729 1.00521 9.17188 1.32812 9.17188H6.82812V14.8281C6.82812 15.151 6.94271 15.4271 7.17188 15.6562C7.40104 15.8854 7.67708 16 8 16C8.32292 16 8.59896 15.8854 8.82812 15.6562C9.05729 15.4271 9.17188 15.151 9.17188 14.8281V9.17188H14.6719C14.9948 9.17188 15.2682 9.05729 15.4922 8.82812C15.7161 8.59896 15.8281 8.32292 15.8281 8C15.8281 7.67708 15.7135 7.40104 15.4844 7.17188C15.2552 6.94271 14.9844 6.82812 14.6719 6.82812Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_169_2743">
          <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0 16)" />
        </clipPath>
      </defs>
    </svg>
  );
};
